module.exports = require('./generateIngredient')
